import * as types from "./types";
import { SubCategory, Business } from "./actions";

type ReducerArgs = {
  type: string;
  payload: any;
};

export type BusinessStepReducer = {
  loading: boolean;
  businesses: Array<Business>;
  subCategories: Array<SubCategory>;
};

const initialState = {
  loading: false,
  businesses: [],
  subCategories: [],
};

export default function (
  state = initialState,
  { type, payload }: ReducerArgs,
): BusinessStepReducer {
  switch (type) {
    case types.SET_LOADING:
      return { ...state, loading: payload as boolean };
    case types.SET_BUSINESSES:
      return { ...state, businesses: payload as Array<Business> };
    case types.SET_SUB_CATEGORIES:
      return { ...state, subCategories: payload as Array<SubCategory> };
    default:
      return state;
  }
}
